import { createPortal } from 'react-dom';

export const renderModal = (modal: React.ReactNode) => {
  const el = document.getElementById('main');
  if (!el) return;

  return createPortal(modal, el);
};
